import { cn } from '@/utils/cn';

interface ScreenModeBadgeProps {
  isNew?:  boolean;
  isEdit?: boolean;
  isView?: boolean;
}

/**
 * The form-mode chip on a master screen: NEW / EDIT / VIEW.
 *
 * Renders nothing in the blank "initial" state. The internal state machine calls that state
 * INITIAL, but that is an implementation name — showing it to a user reads as a stray developer
 * note, so the chip simply disappears until the screen is actually in a record mode.
 */
export const ScreenModeBadge = ({ isNew, isEdit, isView }: ScreenModeBadgeProps) => {
  if (!isNew && !isEdit && !isView) return null;

  return (
    <span className={cn(
      'px-2.5 py-0.5 rounded-full text-xs font-semibold',
      isNew  && 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300',
      isView && 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
      isEdit && 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    )}>
      {isNew ? 'NEW' : isEdit ? 'EDIT' : 'VIEW'}
    </span>
  );
};
